
import { appStateStore } from "@/stores/appState";

export function useModal() {
  const appState = appStateStore();

  function registerOpenModal(id: string | number, disableClose: boolean = false) {
    // console.log('register', id)
    const thisId = id.toString();
    const registered = appState.modalPool.includes(thisId);
    if (appState.modalPoolDisabled == false && disableClose) {
      appState.modalPoolDisabled = true;
    }
    if (!registered) {
      appState.modalPool.push(thisId);
    }
  }
  
  function unregisterModal(id: string | number, disableClose: boolean = false) {
    // console.log('unregister', id)
    const thisId = id.toString();
    if (appState.modalPoolDisabled == true && disableClose) {
      appState.modalPoolDisabled = false;
    }
    appState.modalPool = appState.modalPool.filter((item) => {
      return item !== thisId;
    });
  }
  return {
    registerOpenModal,
    unregisterModal
  };
}
